
interface Props { checked: boolean; onChange: (v: boolean) => void; disabled?: boolean; }

export default function Toggle({ checked, onChange, disabled }: Props) {
  const trackStyle: React.CSSProperties = {
    position: 'relative', display: 'inline-flex',
    width: 48, height: 28, borderRadius: 14,
    background: checked ? 'var(--tg-theme-button-color)' : 'rgba(142,142,147,0.4)',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transition: 'background 0.2s',
    border: 'none', padding: 0, flexShrink: 0,
  };
  const thumbStyle: React.CSSProperties = {
    position: 'absolute', top: 4,
    left: checked ? 24 : 4,
    width: 20, height: 20,
    borderRadius: '50%', background: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
    transition: 'left 0.2s',
  };
  return (
    <button type="button" role="switch" aria-checked={checked}
      disabled={disabled} onClick={() => !disabled && onChange(!checked)}
      style={trackStyle}
    >
      <span style={thumbStyle} />
    </button>
  );
}
